module.exports = __webpack_public_path__ + "static/img/index13.604449b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gif/index13.gif
// module id = F+sW
// module chunks = 0